import { ClientSetting } from '../types/client.enums'

export const CLIENT_VIEW_SETTINGS: { [id: number]: { [key: number]: ClientSetting } } = {
  3000: {
    21: ClientSetting.BusinessFlowType,
    1152: ClientSetting.MyShipment,
    1153: ClientSetting.MyShipmentValue,
    2001: ClientSetting.ServiceRequest,
    2011: ClientSetting.ServiceRequestExtendAccessPointDays,
    2013: ClientSetting.ServiceRequestChangeName,
    2014: ClientSetting.ServiceRequestChangeAddress,
    2015: ClientSetting.ServiceRequestChangePhone,
    2016: ClientSetting.ServiceRequestChangeEmail,
    2018: ClientSetting.ServiceRequestCancelShipment,
    2019: ClientSetting.ServiceRequestChangeDoorAccessCode,
    2021: ClientSetting.ServiceRequestLeaveOutsideDoor,
    2022: ClientSetting.ServiceRequestKnockOnDoor,
    2023: ClientSetting.ServiceRequestNoIdRequirement,
    2024: ClientSetting.ServiceRequestMessageToDriver,
    2025: ClientSetting.ServiceRequestChangeLockerLocation,
    2026: ClientSetting.ServiceRequestNewDeliveryAttempt,
    3111: ClientSetting.ViewDateDisplayName,
  },
  3300: {
    21: ClientSetting.BusinessFlowType,
    1151: ClientSetting.MySelection,
    1152: ClientSetting.MyShipment,
    1153: ClientSetting.MyShipmentValue,
    1176: ClientSetting.ProductPanel,
    1181: ClientSetting.ContextMenu,
    1182: ClientSetting.ContextMenuSendMessage,
    1183: ClientSetting.ContextMenuServiceRequest,
    1184: ClientSetting.ContextMenuShowRelated,
    1186: ClientSetting.ContextMenuActions,
    1188: ClientSetting.ContextMenuEditInformation,
    1190: ClientSetting.ContextMenuServices,
    2001: ClientSetting.ServiceRequest,
    2011: ClientSetting.ServiceRequestExtendAccessPointDays,
    2013: ClientSetting.ServiceRequestChangeName,
    2014: ClientSetting.ServiceRequestChangeAddress,
    2015: ClientSetting.ServiceRequestChangePhone,
    2016: ClientSetting.ServiceRequestChangeEmail,
    2018: ClientSetting.ServiceRequestCancelShipment,
    2019: ClientSetting.ServiceRequestChangeDoorAccessCode,
    2021: ClientSetting.ServiceRequestLeaveOutsideDoor,
    2022: ClientSetting.ServiceRequestKnockOnDoor,
    2023: ClientSetting.ServiceRequestNoIdRequirement,
    2024: ClientSetting.ServiceRequestMessageToDriver,
    2025: ClientSetting.ServiceRequestChangeLockerLocation,
    2026: ClientSetting.ServiceRequestNewDeliveryAttempt,
    3111: ClientSetting.ViewDateDisplayName,
  },
  4000: {
    21: ClientSetting.BusinessFlowType,
    1152: ClientSetting.MyShipment,
    1153: ClientSetting.MyShipmentValue,
    2001: ClientSetting.ServiceRequest,
    2011: ClientSetting.ServiceRequestExtendAccessPointDays,
    2013: ClientSetting.ServiceRequestChangeName,
    2014: ClientSetting.ServiceRequestChangeAddress,
    2015: ClientSetting.ServiceRequestChangePhone,
    2016: ClientSetting.ServiceRequestChangeEmail,
    2018: ClientSetting.ServiceRequestCancelShipment,
    2019: ClientSetting.ServiceRequestChangeDoorAccessCode,
    2021: ClientSetting.ServiceRequestLeaveOutsideDoor,
    2022: ClientSetting.ServiceRequestKnockOnDoor,
    2023: ClientSetting.ServiceRequestNoIdRequirement,
    2024: ClientSetting.ServiceRequestMessageToDriver,
    2025: ClientSetting.ServiceRequestChangeLockerLocation,
    2026: ClientSetting.ServiceRequestNewDeliveryAttempt,
    3111: ClientSetting.ViewDateDisplayName,
  },
  4300: {
    21: ClientSetting.BusinessFlowType,
    1751: ClientSetting.MySelection,
    1152: ClientSetting.MyShipment,
    1153: ClientSetting.MyShipmentValue,
    1776: ClientSetting.ProductPanel,
    1781: ClientSetting.ContextMenu,
    1782: ClientSetting.ContextMenuSendMessage,
    1783: ClientSetting.ContextMenuServiceRequest,
    1784: ClientSetting.ContextMenuShowRelated,
    1786: ClientSetting.ContextMenuActions,
    1788: ClientSetting.ContextMenuEditInformation,
    1790: ClientSetting.ContextMenuServices,
    2001: ClientSetting.ServiceRequest,
    2011: ClientSetting.ServiceRequestExtendAccessPointDays,
    2013: ClientSetting.ServiceRequestChangeName,
    2014: ClientSetting.ServiceRequestChangeAddress,
    2015: ClientSetting.ServiceRequestChangePhone,
    2016: ClientSetting.ServiceRequestChangeEmail,
    2018: ClientSetting.ServiceRequestCancelShipment,
    2019: ClientSetting.ServiceRequestChangeDoorAccessCode,
    2021: ClientSetting.ServiceRequestLeaveOutsideDoor,
    2022: ClientSetting.ServiceRequestKnockOnDoor,
    2023: ClientSetting.ServiceRequestNoIdRequirement,
    2024: ClientSetting.ServiceRequestMessageToDriver,
    2025: ClientSetting.ServiceRequestChangeLockerLocation,
    2026: ClientSetting.ServiceRequestNewDeliveryAttempt,
    3111: ClientSetting.ViewDateDisplayName,
  },
}

export const MOTION_CLIENT_SETTINGS: number[] = [
  21, 1151, 1152, 1153, 1176, 1181, 1182, 1183, 1184, 1186, 1188, 1190, 1751, 1776, 1781, 1782,
  1783, 1784, 1786, 1788, 1790, 2001, 2011, 2013, 2014, 2015, 2016, 2018, 2019, 2021, 2022, 2023,
  2024, 2025, 2026, 2502, 3111,
]

export const DASHBOARD_CLIENT_SETTINGS: number[] = [1080, 1151, 1152, 1153, 2502, 3111]
